<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">並び順の設定</span>
        </div>
        <div class="popup-content">
          <div class="formparts radio" v-for="item in data" :key="item.value">
            <input type="radio" :value="item.value" :id="'knowledge_search_order_setting_' + item.value" v-model="state.selected">
            <label role="button" :for="'knowledge_search_order_setting_' + item.value">{{item.name}}</label>
          </div>
          <div class="button mt32">
            <button class="btn" @click="submit">設定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import * as _ from 'lodash'

export default defineComponent({
  props: {
    isKeywordsEmpty: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const close = () => {
      context.emit('close')
    }

    const submit = () => {
      const result = _.find(data, { value: state.selected})
      const settingParam = {
        searchOrder: result.searchOrder,
        ascending: result.ascending
      }

      store.dispatch('precedent/updateSearchSetting', settingParam)
      context.emit('submit')
    }

    const originalData = [
      {
        value: 0,
        name: '関連度順',
        searchOrder: 'score',
        ascending: 'desc'
      },
      // {
      //   value: 1,
      //   name: '関連度順（昇順）',
      //   searchOrder: 'score',
      //   ascending: 'asc'
      // },
      {
        value: 2,
        name: '年月日順（新しい順）',
        searchOrder: 'date',
        ascending: 'desc'
      },
      {
        value: 3,
        name: '年月日順（古い順）',
        searchOrder: 'date',
        ascending: 'asc'
      }
    ]
    
    let data = originalData
    if (props.isKeywordsEmpty) {
      data = _.filter(originalData, item => item.value !== 0)
    }

    const state = reactive({
      searchOrder: computed(() => {
        return store.state.precedent.searchSetting.searchOrder
      }),
      ascending: computed(() => {
        return store.state.precedent.searchSetting.ascending
      }),
      selected: null
    })
    onMounted(() => {
      const result = _.find(data, { searchOrder: state.searchOrder, ascending: state.ascending})
      if (result) {
        state.selected = result.value
      } else {
        // 元の設定が関連度順でキーワード未入力でプルダウンが隠されていた場合
        if (props.isKeywordsEmpty) {
          const result2 = _.find(data, { searchOrder: 'date', ascending: state.ascending})
          state.selected = result2.value
        } 
      }
    })

    return {
      data,
      state,
      submit,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
